// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useCallback, useState } from "react";
import { connect } from "react-redux";
import Modal from "react-modal";

import { StyledModal, InfoMessage, Buttons } from "./styles";

import type { AppState } from "src/types";

import ButtonLoader from "src/components/ButtonLoader";
import { Form } from "src/styles/form";

import { closeInfoModal } from "src/actions/modal";
import { Secondary } from "src/styles/buttons";

type Props = {
  infoModal: {
    isOpen: boolean,
    message: string,
    confirmAction: Function,
    type: string,
  },

  closeInfoModal: Function,
};

const InfoModal = ({ infoModal, closeInfoModal }: Props) => {
  const { isOpen, message, confirmAction, type } = infoModal;
  const [isLoading, setIsLoading] = useState(false);

  const submitForm = useCallback(
    (e) => {
      e.preventDefault();
      setIsLoading(true);
      confirmAction();
    },
    [confirmAction],
  );

  const getButtons = useCallback(() => {
    switch (type) {
      case "CONFIRMATION":
        return (
          <Buttons>
            <Secondary type="button" onClick={closeInfoModal}>
              {i18n.t(k.CANCEL)}
            </Secondary>
            <ButtonLoader type="submit" isLoading={isLoading}>
              {i18n.t(k.DELETE)}
            </ButtonLoader>
          </Buttons>
        );

      case "INFORMATION":
        return (
          <Buttons>
            <Secondary type="button" onClick={closeInfoModal}>
              {i18n.t(k.CLOSE1)}
            </Secondary>
          </Buttons>
        );

      default:
        return null;
    }
  }, [type, closeInfoModal, isLoading]);

  return (
    <StyledModal id="info-modal" onClick={closeInfoModal}>
      <Modal
        isOpen={isOpen}
        parentSelector={() => document.querySelector("#info-modal")}
      >
        <Form onClick={(e) => e.stopPropagation()} onSubmit={submitForm}>
          <InfoMessage>{message}</InfoMessage>
          {getButtons()}
        </Form>
      </Modal>
    </StyledModal>
  );
};

const mapStateToProps = ({ app }: { app: AppState }) => ({
  infoModal: app.modal.infoModal,
});

export default connect(mapStateToProps, { closeInfoModal })(InfoModal);
